import { SalonIndex } from 'booking/components';
import { FullscreenImageLayout } from 'ui-components';
import { useDocumentTitle } from 'usehooks-ts';

export function Salons(): JSX.Element {
  useDocumentTitle('DRYCUT - Salons');

  return (
    <FullscreenImageLayout src="/images/booking-bg.jpg">
      <SalonIndex />
    </FullscreenImageLayout>
  );
}
